import { useState, useEffect } from 'react';
import { ReplaySubject } from 'rxjs';

export const primaryNavHeightObs = new ReplaySubject(1);

export function recalculatePrimaryNavHeight(loggedInUser, tenant) {
  const isClient = !!loggedInUser.effective_permissions.client;
  if (!isClient) {
    primaryNavHeightObs.next(0);
  } else {
    const navbarHeight = isClient ? 72 : 56;

    primaryNavHeightObs.next(navbarHeight);
  }
}

export function usePrimaryNavHeight() {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const height$ = primaryNavHeightObs.subscribe(newHeight => {
      setHeight(newHeight);
    });

    return () => {
      height$.unsubscribe();
    };
  }, []);

  return height;
}
